// wxshare 配置，用于二次分享卡片样式
export const DEFAULT_SHARE_CONFIG = {
  title: '小黑盒',
  desc: '高能玩家聚集地',
  link: window.location.href,
  imgUrl: 'https://cdn.max-c.com/heybox/logo/app_251.png',
}

// 打开app默认协议
export const DEFAULT_OPEN_APP_PROTOCOL = {
  protocol_type: 'openWindow',
  webview: {
    url: window.location.href,
  }
}

// INFO shareheader支持的配置参数
export const DEFAULT_SHARE_HEADER_CONFIG = {
  logoImg: 'https://cdn.max-c.com/heybox/logo/app_251.png',
  title: '小黑盒',
  desc: '高能玩家聚集地',
  btnDesc: '打开看看',
  opacity: '0.9',
  useFixed: false,
  clientType: 'heybox',
  protocol: null, // 用于覆盖默认的openapp协议
}

// INFO open-app支持的配置参数
export const DEFAULT_OPEN_APP_CONFIG = {
  protocol: {
    protocol_type: 'openWindow',
    webview: {
      url: window.location.href,
    }
  },
  weixinShareConfig: DEFAULT_SHARE_CONFIG,
}